<template>
  <div class="swiper">
    <div class="swiper-wrapper">
      <div
        v-for="item in allPhotos"
        :key="item.id"
        class="swiper-slide"
      >
        <el-image
          style="width: 100%; height: 100%"
          :src="mediaUrl + item.path"
          fit="fill"
        />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { mediaUrl } from "@/utils/base";

export default {
  name: "PatientImageSwiper",
  props: {
    allPhotos: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      mediaUrl: mediaUrl,
    };
  },
  mounted() {
    setTimeout(() => {
      new Swiper(".swiper", {
        autoplay: false, // 可选选项，自动滑动
        pagination: {
          el: ".swiper-pagination",
        },
        clickable: true,
      });
    }, 300);
  }
};
</script>

<style scoped lang="scss">
.swiper ::v-deep {
  width: 600px;
  height: 750px;
  overflow: hidden;

  .swiper-pagination-bullet {
    width: 20px;
    height: 20px;
  }

}
</style>
